import { createFileRoute, Navigate } from "@tanstack/react-router";
import { isAdminAuthenticated } from "@/lib/adminAuth";
import { adminPath } from "@/lib/adminRoute";

export const Route = createFileRoute("/pulse-ops-x7k2/")({
  component: AdminIndex,
});

function AdminIndex() {
  if (isAdminAuthenticated()) {
    return <Navigate to={adminPath("dashboard")} />;
  }
  return null;
}
